export default "__VITE_ASSET__CuXf9YwW__"